import { useState, useEffect, useContext } from "react";
import { useApolloClient } from "@apollo/client";
import apiCall from "../../utility/api";
import { useLocation } from "react-router-dom";
import { GlobalContext } from "../../hooks/globalContext";

type TenantType = {
  setClientVersionsList?: any;
  setDropDownValueIosVersion?: any;
  setDropDownValueAndroidVersion?: any;
  setDropDownValueWindowsVersion?: any;
  setClientExecutableFiles?: any;
  setLicenseDetails?: any;
  licenseDetails?: any;
  setDropDownValueMACIntel?: any;
  setDropDownValueMACVersion?: any;
  setDropDownValueAndroidApk?: any;
  setDropDownValueWin64?: any;
  setDropDownValue?: any;
  setOverlayName?: any;
  setSaveBtnClicked?: any;
  overlayOpen?: boolean;
  data?: any;
  func?: any;
  searchVal?: string | any;
  pageNo?: string | number | any;
  setTotalPages?: any;
  setTotalRecords?: any;
  isFilter?: boolean;
  setIsFilter?: any;
  dropDownValue1?: any;
  dropDownValue2?: any;
  isRefresh?: boolean;
  setIsRefresh?: any;
  setRefreshToast?: any;
  setOverlayOpen?: any;
  setEmailExistsToast?: any;
  setExportBtnClicked?: any;
  exportBtnClicked?: any;
  filterArray?: any;
  setIsToast?: any;
  setExportDetails?: any;
  setOptions?: any;
  email?: any;
  refreshToast?: any;
  rowID?: any
  setRowID?: any
  dropdownData?: any
  setClientList?: any
  overlayName?: string;
  formData?: any;
  setFormData?: any;
  sitename?: any;
  formEditData?: any;
  setFormEditData?: any;
  saveBtnClicked?: boolean;
  setErrorToast?: any;
  setToastMessage?: any;
  site?: string;
  setDownloadURL?: any;
  setDownloadFileName?: any;
  tenant?: any;
  setSpinnerLoad?: any;
};

export const Tenant_func = (props: TenantType) => {
  console.log("props.licenseDetails=", props.licenseDetails);
  const contextValue: any = useContext(GlobalContext);
  const currentTenant = contextValue?.tenantName;

  const location = useLocation();
  const [myData, setMydata] = useState(null);

  const getSiteList = async () => {
    try {
      const email = props.email;
      const { data, status } = await apiCall("/tenant/getList", { function: "user", email });

      if (status === "success" && data.length > 0) {
        // Extract the tenant string
        let tenantString = data[0].tenant;

        // Split the tenant string into an array
        let siteData = tenantString ? tenantString.split(",").map((s: string) => s.trim()) : [];
        setMydata(siteData);
        props.setOptions(siteData);
      }
    } catch (error) {
      console.log("getSiteList error=", error);
      setMydata([]);
      props.setOptions([]);
    }
  };

  const getTenantList = async (whereCondition: any, limit: Number, offset: Number) => {
    try {
      let { data, status } = await apiCall("/tenant/getSiteList", { ...whereCondition, limit, offset });

      if (status === "success") {
        props.func(data);
        props.setClientList(data);
      }
    } catch (error) {
      console.error("getTenantList error=", error);
    }
  };

  const getTenantListCount = async (whereCondition: any) => {
    try {
      let { data, status } = await apiCall("/tenant/getCount", whereCondition);
      if (status === "success" && data.totalRecords > 0) {
        props?.setTotalRecords(data.totalRecords);
        props?.setTotalPages(data.totalPages);
      }
    } catch (error) {
      console.error("getTenantList", error);
    }
  };

  const getExportData = async (condition: object) => {
    try {
      let { data, status } = await apiCall("/tenant/getSiteList", condition);
      console.log("getExportData", data);
      if (status === "success") {
        props.setExportDetails(data);
      }
    } catch (error) {
      console.log("getExportData error=", error);
    }
    props.setExportBtnClicked(false);
  }

  const getTenantDetails = async (siteId: number) => {
    try {
      let { data, status } = await apiCall('/tenant/getTenantFormDetails', { siteId });

      if (status === 'success' && data) {
        const selectedTenantData = data[0];  // Extract the first tenant from the data array

        props.setFormData({
          tenant: selectedTenantData?.sitename || '',
          "client_32_name": selectedTenantData?.client_32_name || '',
          "client_64_name": selectedTenantData?.client_64_name || '',
          androidClient: selectedTenantData?.client_android_name || '',
          macVersion: selectedTenantData?.client_mac_name || '',
          macIntel: selectedTenantData?.macIntel || '',
          "windowsVersion": selectedTenantData?.client_windows_version || "",
          "androidVersion": selectedTenantData?.client_android_version || "",
          "iosVersion": selectedTenantData?.client_ios_version || "",
        });

        props.setDropDownValue(selectedTenantData?.client_32_name || '');
        props.setDropDownValueWin64(selectedTenantData?.client_64_name || '');
        props.setDropDownValueAndroidApk(selectedTenantData?.client_android_name || '');
        props.setDropDownValueMACVersion(selectedTenantData?.client_mac_name || '');
        props.setDropDownValueMACIntel(selectedTenantData?.macIntel || '');

        props.setDropDownValueWindowsVersion(selectedTenantData?.client_windows_version || '');
        props.setDropDownValueAndroidVersion(selectedTenantData?.client_android_version || '');
        props.setDropDownValueIosVersion(selectedTenantData?.client_ios_version || '');
        setTimeout(()=>{props.setSpinnerLoad(false);},1000) 
      } else {
        console.log("No data found");
        props.setFormData([]);
      }
    } catch (error) {
      console.error("getTenantDetails error=", error);
      props.setFormData([]);
    }
  }

  const addTenant = async (tenantDetails: any) => {
    const updatedTenantDetails = { ...tenantDetails, androidVersion: tenantDetails.androidVersion[0], iosVersion: tenantDetails.iosVersion[0], windowsVersion: tenantDetails.windowsVersion[0], currentTenant };

    try {
      const { status, data, msg } = await apiCall('/tenant/add', updatedTenantDetails);

      if (status === 'success') {
        props.setOverlayOpen(false);
        props.setIsToast(true);

      } else {
        props.setOverlayOpen(false);

        props.setToastMessage(msg);
        props.setErrorToast(true);
      }

      setTimeout(() => {
        props.setSaveBtnClicked(false);
        props.setOverlayName('');
      }, 3000);
      console.log("newSiteName added==", data);
    } catch (error) {
      console.log("addTenant error=", error);

      props.setOverlayOpen(false);
      props.setToastMessage('Tenant creation failed');
      props.setErrorToast(true);

      setTimeout(() => {
        props.setSaveBtnClicked(false);
        props.setOverlayName('');
      }, 3000);
    }
  }

  const updateTenant = async (tenantDetails: any) => {
    let androidVersion = tenantDetails.androidVersion,
      iosVersion = tenantDetails.iosVersion,
      windowsVersion = tenantDetails.windowsVersion;

    if (typeof androidVersion === "object") {
      androidVersion = androidVersion[0];
    }

    if (typeof iosVersion === "object") {
      iosVersion = iosVersion[0];
    }

    if (typeof windowsVersion === "object") {
      windowsVersion = windowsVersion[0];
    }

    const updatedTenantDetails = { ...tenantDetails, androidVersion: androidVersion, iosVersion: iosVersion, windowsVersion: windowsVersion, currentTenant };

    try {
      const { status, data, msg } = await apiCall('/tenant/update', updatedTenantDetails);

      if (status === 'success') {
        props.setOverlayOpen(false);
        props.setIsToast(true);

      } else {
        props.setOverlayOpen(false);

        props.setToastMessage(msg);
        props.setErrorToast(true);
      }

      setTimeout(() => {
        props.setSaveBtnClicked(false);
        props.setOverlayName('');
      }, 3000);
    } catch (error) {
      console.log("updateTenant error=", error);

      props.setOverlayOpen(false);
      props.setToastMessage('Tenant details updation failed');
      props.setErrorToast(true);

      setTimeout(() => {
        props.setSaveBtnClicked(false);
        props.setOverlayName('');
      }, 3000);
    }
  }

  const getLicensDetails = async (site: string) => {
    try {
      let { data, status } = await apiCall("/tenant/licenseDetails", { tenant: site });

      if (status === "success") {
        props.setLicenseDetails({
          ...props.licenseDetails,
          totalCnt: data[0].totalLicenseCnt,
          usedCnt: data[0].licenseUsed
        });
      }
    } catch (error) {
      console.log("getLicensDetails error=", error);
    }
  }

  const downloadClientURL = async (site: string) => {
    try {
      let { data, status, msg } = await apiCall('/tenant/download', { tenant: site });

      if (status === 'success') {
        data?.length > 0 && props.setDownloadURL(data[0].link);
        data?.length > 0 && props.setDownloadFileName(data[0].name);
        msg?.length > 0 && props.setDownloadURL(msg);

      } else if (msg?.length > 0) {
        msg === 'No. of installation exceeded for the provided tenant' && props.setDownloadURL('No. of installation exceeded the total license count');
      }
    } catch (error) {
      console.log("downloadClient error=", error);
    }
  }

  const getFilesList = async () => {
    try {
      const { data, status } = await apiCall('/tenant/getExecutableFiles');

      if (status === 'success') {
        const newData = data.map((val) => val.Key).filter((val) => val.length > 0);

        props.setClientExecutableFiles(newData);
      }
    } catch (error) {
      console.log("getFilesList error=", error);
    }
  }

  const getClientVersionsList = async () => {
    try {
      const { data, status } = await apiCall('/tenant/getClientVersionsList');

      if (status === 'success') {
        props.setClientVersionsList(data);
      }
    } catch (error) {
      console.log("getClientVersionsList error=", error);
    }
  }

  useEffect(() => {
    getFilesList();
    // Only call getSiteList if the current path is NOT the tenant page
    if (location.pathname !== "/manage/administration/tenant") {
      getSiteList();
    }
    if (location.pathname !== '/Dashboard') {
      if (props.saveBtnClicked && props.overlayName === 'addTenant') {
        addTenant(props.formData);
      } else if (props.saveBtnClicked && props.overlayName === 'editTenant') {
        updateTenant(props.formData);
      }
      // else if ((props?.searchVal?.length > 0 && props.searchVal !== "") && props.isFilter) {
      //   console.log("calling both condition");
      //   getTenantList({ search: props.searchVal, filter: props.filterArray, function: "search_filter" },50,parseInt(props.pageNo));
      //   getTenantListCount({ search: props.searchVal, filter: props.filterArray, function: "search_filter" });
      // } 
      else if (props?.searchVal?.length > 0 && props.searchVal !== "") {
        getTenantList({ search: props.searchVal, function: "search" }, 50, parseInt(props.pageNo));
        getTenantListCount({ search: props.searchVal, function: "search" });
      } else if (props.isFilter === true) {
        getTenantList({ filter: props.filterArray, function: "filter" }, 50, props.pageNo);
        getTenantListCount({ filter: props.filterArray, function: "filter" });
      } else if (props.isRefresh) {
        props.setIsRefresh(false);
        getTenantList(null, 50, parseInt(props.pageNo));
        getTenantListCount(null);
        props.setRefreshToast(true);
        setTimeout(() => {
          props.setRefreshToast(false);
        }, 3000);
      } else if (props.exportBtnClicked) {
        getExportData({ function: 'export', tenant: props.tenant });
      } else if (location.pathname !== "/home") {
        getTenantList(null, 50, parseInt(props.pageNo));
        getTenantListCount(null);
      }
      console.log("props.overlayName=", props.overlayName);

      if (!props.saveBtnClicked && (props.overlayName === 'editTenant' || props.overlayName === 'addTenant')) {
        getClientVersionsList();
      }

      if (!props.isRefresh && props.rowID && !(props.saveBtnClicked) && props.overlayName === 'editTenant') {
        getTenantDetails(props.rowID);
        getLicensDetails(props.site);
        downloadClientURL(props.site);
      }
    }
  }, [props.searchVal, props.isFilter, props.filterArray, props.isRefresh, props.exportBtnClicked, location.pathname, props.overlayName, props.saveBtnClicked, props.rowID]);

  return myData;
};